/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */
import React from "react";
// import { useNavigate } from "react-router-dom";
import { Box, Tooltip } from "@mui/material";
import StatBox from "../StatBox";

export default function DashboardDataTiles({ contents }) {
  // const navigate = useNavigate();

  const chunkArray = (array, chunkSize) => {
    const result = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      result.push(array.slice(i, i + chunkSize));
    }
    return result;
  };

  const chunkedContents = chunkArray(contents, 2);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        flexWrap: "wrap",
        gap: "4vw",
      }}
    >
      {chunkedContents.map((chunk) => (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
            gap: "4vw",
          }}
        >
          {chunk.map((content) => (
            <Tooltip title={content?.onHoverTitle} placement="top">
              <Box
                onClick={() => content?.onClickFunction()}
                sx={{
                  background: content?.tileColor,
                  boxShadow: "5px 5px 5px rgba(0, 0, 0, 0.3)",
                  borderRadius: "20px",
                  width: "18vw",
                  minWidth: "290px",
                  // maxWidth: "350px",
                  cursor: "pointer",
                  transition: "all .3s",
                  py: 2,
                  mb: 2,
                  "&:hover": {
                    boxShadow: "3px 3px 10px 5px rgba(0, 0, 0, 0.3)",
                  },
                  "@media (max-width: 1550px)": {
                    // width: "18vw",
                    minWidth: "230px",
                    // maxWidth: "350px",
                  },
                }}
              >
                <StatBox
                  title={content?.value}
                  subtitle={content?.title}
                  icon={content?.icon}
                />
              </Box>
            </Tooltip>
          ))}
        </Box>
      ))}
    </Box>
  );
}
